import React, { useEffect, useState } from 'react';
import { useI18n } from '../lib/i18n';
import { Menu, X } from 'lucide-react';
export function Nav() {
  const {
    t,
    lang,
    setLang
  } = useI18n();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    setMobileMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const navLinks = [{
    id: 'marco',
    label: t('nav.marco')
  }, {
    id: 'aplicaciones',
    label: t('nav.aplicaciones')
  }, {
    id: 'motor',
    label: t('nav.motor')
  }, {
    id: 'timeline',
    label: t('nav.timeline')
  }, {
    id: 'papers',
    label: t('nav.papers')
  }, {
    id: 'autor',
    label: t('nav.autor')
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/80 backdrop-blur-md border-b border-black/[0.06] py-3' : 'bg-transparent py-5'}`} data-id="element-159">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-160">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-161">
          <span className="font-display text-2xl tracking-tight text-[#0A0A0F]" data-id="element-162">
            CLVN–LRR™
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8" data-id="element-163">
          <div className="flex items-center gap-6" data-id="element-164">
            {navLinks.map(link => <button key={link.id} onClick={() => scrollTo(link.id)} className="text-sm text-[#4A4A55] hover:text-[#0A0A0F] transition-colors" data-id="element-165">
                {link.label}
              </button>)}
          </div>

          <div className="flex items-center gap-4 border-l border-black/10 pl-4" data-id="element-166">
            <button onClick={() => setLang(lang === 'es' ? 'en' : 'es')} className="text-xs font-mono text-[#4A4A55] hover:text-[#0A0A0F] transition-colors uppercase tracking-widest" data-id="element-167">
              {lang === 'es' ? 'EN' : 'ES'}
            </button>

            <button onClick={() => scrollTo('papers')} className="text-sm font-medium bg-[#0A0A0F] text-white px-4 py-1.5 rounded-full hover:bg-[#2A2A35] transition-colors" data-id="element-168">
              {t('nav.leerPaper')}
            </button>
          </div>
        </div>

        <button className="md:hidden text-[#4A4A55] hover:text-[#0A0A0F]" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-169">
          {mobileMenuOpen ? <X size={24} data-id="element-170" /> : <Menu size={24} data-id="element-171" />}
        </button>
      </div>

      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-black/[0.06] p-6 flex flex-col gap-4 shadow-sm" data-id="element-172">
          {navLinks.map(link => <button key={link.id} onClick={() => scrollTo(link.id)} className="text-left text-lg text-[#0A0A0F] hover:text-violet-700" data-id="element-173">
              {link.label}
            </button>)}
          <div className="h-px bg-black/[0.08] my-2" data-id="element-174" />
          <div className="flex items-center justify-between" data-id="element-175">
            <button onClick={() => setLang(lang === 'es' ? 'en' : 'es')} className="text-sm font-mono text-[#4A4A55] hover:text-[#0A0A0F] uppercase tracking-widest" data-id="element-176">
              {lang === 'es' ? 'Switch to English' : 'Cambiar a Español'}
            </button>
            <button onClick={() => scrollTo('papers')} className="text-sm font-medium bg-[#0A0A0F] text-white px-4 py-2 rounded-full" data-id="element-177">
              {t('nav.leerPaper')}
            </button>
          </div>
        </div>}
    </nav>;
}